<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 11:38:27
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 11:30:21
 * @Description: 新建/编辑考试
 -->
<template>
  <div class="create-edit-examination">
    <create-header
      :title="isEdit ? '编辑考试': '新建考试'"
    />
    <!-- 切换 -->
    <div class="change-box">
      <mk-radio-group
        v-model="curContent"
      >
        <mk-radio-button label="basicInfo">
          基本信息
        </mk-radio-button>
        <mk-radio-button label="paperManage">
          试题管理
        </mk-radio-button>
      </mk-radio-group>
    </div>
    <!-- 表单内容 -->
    <!-- <components
      :is="curContent"
      ref="childForm"
      :is-edit="isEdit"
      :examination-info="examinationInfo"
    /> -->
    <basic-info
      v-show="curContent==='basicInfo'"
      ref="basicInfo"
      :is-edit="isEdit"
      :examination-info="examinationInfo"
    />
    <!-- :is="curContent" -->

    <paper-manage
      v-show="curContent==='paperManage'"
      ref="paperManage"
      :is-edit="isEdit"
      :examination-info="examinationInfo"
    />
    <div class="save-examination">
      <mk-button-biz
        class="save-examination-btn"
        width="96px"
        height="32px"
        @click="handleOnSaveExaminationClick"
      >
        保存考试
      </mk-button-biz>
    </div>
  </div>
</template>
<script>
import createHeader from '@components/create-header'
import PaperManage from './paper-manage'
import BasicInfo from './basic-info'
import { mapMutations } from 'vuex'
export default {
  name: 'CreateEditExamination',
  components: { PaperManage, BasicInfo, createHeader },
  props: {},
  data () {
    return {
      isEdit: false,
      examinationId: '',
      curContent: 'basicInfo',
      examinationInfo: {}
    }
  },
  computed: {
    // 当前总分数
    curPaperTotalScore () {
      return this.$store.state['examination-manage'].curPaperTotalScore
    },
    // 当前相同分状态
    curSameState () {
      return this.$store.state['examination-manage'].curSameState
    },
    // 当前相同分
    curSameScore () {
      return this.$store.state['examination-manage'].curSameScore
    }
  },
  // created () {
  //   // 如果路径携带Id参数，表示为编辑状态，调用请求试卷详情接口回显数据
  //   if (this.$route.query._id) {
  //     this.isEdit = true
  //     this.paperGetGet(this.$route.query._id)
  //   }
  // },
  activated () {
    // 如果路径携带Id参数，表示为编辑状态，调用请求试卷详情接口回显数据
    if (this.$route.query._id) {
      this.isEdit = true
      this.paperGetGet(this.$route.query._id)
    }
  },
  // mounted () {},
  // // 页面销毁时 初始化 vuex 存储的实时数据
  // destroyed () {
  //   this.initParams()
  // },
  deactivated () {
    this.initParams()
    this.$destroy()
  },
  methods: {
    // 存入 试卷实时计算总分
    ...mapMutations('examination-manage', {
      setCurPaperTotalScore: 'SET_CURPAPERTOTALSCORE',
      initParams: 'INIT_PARAMS'
    }),
    // 编辑时获取详情
    async paperGetGet (val) {
      let res = await MBASVCAPIS.PaperApi.paperGetGet({ _id: val })
      if (res.success) {
        this.examinationInfo = res.data
        // 左侧存入 当前总分
        this.setCurPaperTotalScore(this.examinationInfo.paperInfo.score)
        // 传入子级
        this.$refs.basicInfo.setData(this.examinationInfo)
        this.$refs.paperManage.setData(this.examinationInfo)
      }
    },
    // 保存考试
    handleOnSaveExaminationClick () {
      // 获取 基础数据
      let basicInfoData = this.$refs.basicInfo.returnData()
      if (!basicInfoData.tags) {
        basicInfoData.tags = []
      }
      // 获取 表单管理数据
      let paperManageData = this.$refs.paperManage.returnData()
      let params = {
        ...basicInfoData,
        ...paperManageData
      }
      // 如果验证未通过，阻断提交
      let valid = this.validateData(params)
      if (!valid) {
        return false
      }
      // 编辑时，携带参数
      if (this.isEdit) {
        let otherParams = {
          _id: this.examinationInfo.paperInfo._id
        }
        params = {
          ...params,
          ...otherParams
        }
        this.paperUpdatePut(params)
      } else {
        this.paperCreatePost(params)
      }
    },
    // 校验数据
    validateData (data) {
      let emptyArr = []
      data.questions.map((item, index) => {
        if (!item.score) {
          emptyArr.push(index + 1)
        }
      })
      if (!data.name) {
        // 验证基本信息表单
        this.curContent = 'basicInfo'
        this.$refs['basicInfo'].$refs['basicInfoForm'].validate()
        return false
      } else if (data.questions.length === 0) {
        // 验证是否有试题
        this.curContent = 'paperManage'
        this.$message.error('请至少添加一道试题')
        return false
      } else if (emptyArr.length > 0) {
        // 验证是否有空分试题
        this.$message.error(`当前第${emptyArr.join('、')}道题分数为空，请重新设置分数`)
        return false
      } else if (!data.passScore) {
        // 验证是否设置通过分数
        this.curContent = 'paperManage'
        this.$message.error('当前通过分数未设置，请重新设置通过分数')
        return false
      } else if (data.passScore > this.curPaperTotalScore) {
        // 验证通过分数大于总分
        this.$message.error('通过分数不能大于总分')
      } else if (this.curSameState && !this.curSameScore) {
        // 当前相同分校验是否已填
        this.$message.error('请输入每题相同分')
        return false
      } else {
        return true
      }
    },
    // 编辑接口
    async paperUpdatePut (params) {
      let res = await MBASVCAPIS.PaperApi.paperUpdatePut(
        {
          _id: params._id
        },
        params
      )
      if (res.success) {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.$router.go(-1)
      }
    },
    // 新建接口
    async paperCreatePost (params) {
      let res = await MBASVCAPIS.PaperApi.paperCreatePost(params)
      if (res.success) {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.create-edit-examination {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  position: relative;

  /deep/ .el-radio {
    font-weight: 400;
  }

  /deep/.el-input-number {
    height: 28px !important;

    .el-input__inner {
      padding: 0;
    }
  }
  // 切换组件
  .change-box {
    padding: 20px;

    /deep/ .el-radio-button__inner {
      padding: 8px 15px;
    }
  }
  // 保存按钮
  .save-examination {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    padding: 12px 0;

    .save-examination-btn {
      background-color: #009cff;
      color: #fff;
      font-size: 13px;
      font-weight: 400;
      border: 0;
    }
  }
}
</style>
